import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Fetch Campaign ROI & Performance Report
export const getCampaignReport = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/CampaignReport/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching campaign report:", error);
    throw error;
  }
};

// Export Campaign Report to Excel
export const exportCampaignReport = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/CampaignReport/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const ts = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '_');
    link.setAttribute('download', `CampaignReport_${ts}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error exporting campaign report:", error);
    throw error;
  }
};
